/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crisp_Warm_Fox_SkipInputs */

const en_crisp_warm_fox_skip = /** @type {(inputs: Crisp_Warm_Fox_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exclude round`)
};

const de_crisp_warm_fox_skip = /** @type {(inputs: Crisp_Warm_Fox_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runde ausschließen`)
};

/**
* | output |
* | --- |
* | "Exclude round" |
*
* @param {Crisp_Warm_Fox_SkipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const crisp_warm_fox_skip = /** @type {((inputs?: Crisp_Warm_Fox_SkipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crisp_Warm_Fox_SkipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crisp_warm_fox_skip(inputs)
	return de_crisp_warm_fox_skip(inputs)
});